module.exports = __webpack_public_path__ + "static/img/applicableScene7.1b55d95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene7.png
// module id = 5Lkp
// module chunks = 0